































import { Vue, Component, Prop, Watch } from 'vue-property-decorator'
// import { State, Getter, Action, Mutation, namespace } from 'vuex-class'
import { maskingEmail, maskingPhone } from '../../services/Helpers'

@Component
export default class Success extends Vue {
  private keyEmail: string = 'email'
  private keyPhone: string = 'phoneNumber'
  private email: string = localStorage![this.keyEmail]
  private phone: string = localStorage![this.keyPhone]

  get censoredEmail() {
    return maskingEmail(this.email)
  }

  get censoredPhone() {
    return maskingPhone(this.phone)
  }

  get messages() {
    return this.phone ? this.censoredEmail : this.censoredEmail + ' and SMS in ' + this.censoredPhone
  }
}
